import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { StyledInputContainer } from './Input'
import Icon, { StyledIcon } from '../general/Icon'
import Message from './Message'

const NativeSelect = ({ children, data, errors, onChange, onClick, value }) => {
	const message = errors.reduce((accumulator, error) => `${accumulator}${error} `, '')

	return (
		<StyledNativeSelect>
			<StyledInputContainer>
				<select
					onChange={e => onChange(e.target.value)}
					value={value || ''}
					onClick={onClick}
				>
					{children && !data && children}
					{data && !children && data.map(({ value, label }) => (
						<option
							key={value}
							value={value}
						>
							{label}
						</option>
					))}
				</select>
				<Icon name="chevron-down" />
			</StyledInputContainer>
			{message !== '' && (
				<Message small>
					{message}
				</Message>
			)}
		</StyledNativeSelect>
	)
}

NativeSelect.propTypes = {
	children: PropTypes.any,
	data: PropTypes.array,
	errors: PropTypes.array,
	onChange: PropTypes.func.isRequired,
	onClick: PropTypes.func,
	value: PropTypes.any
}

NativeSelect.defaultProps = {
	children: null,
	data: null,
	errors: [],
	onClick: null,
	value: null
}

export const StyledNativeSelect = styled.div`
	${StyledInputContainer} > ${StyledIcon} {
		color: ${props => props.theme.backgroundSolid};
		cursor: text;
		pointer-events: none;

		position: absolute;
		top: calc(50% + 8px);
		left: auto;
		right: 0.5rem;
		transform: translate(0, -50%);
	}
`

export default NativeSelect
